<template>
<div class="chapter">
<div class="inner_page">
<h2><a id="prologue"></a>A Prologue</h2>
<p class="first">Six months before he died he told his daughter that he had not wanted to remarry her mother. He was brushing his teeth while he told her. She liked to watch him brush his teeth. He was so efficient, so dedicated, so determined.</p>
<p>“I did it to save the children,” he said. “I came back to save the children.”</p>
<p>“You gave up the mistress to save what children?” the daughter asked.</p>
<p>“To save Juliet. She was running around with the wrong crowd. She was going out with a black.”</p>
<p>“So you tore up the life Mother was making for herself and made her marry you again to save Juliet?”</p>
<p>“Had to do it. Had to stop that.” He was flossing now. He had been the first person she knew who used dental floss. It had been given to him by the pathological dentist who had ruined all their teeth in the sixties.</p>
<p>The old man was eighty-eight when this conversation took place. The year after he lost all the money. The year before they took his car away and then his gun. He had had at one time almost twenty million dollars but he had lost it all. He had lost it by believing in his sons. Or else, he had lost it by being afraid to invest in the markets, by being afraid of the contemporary world, by being a racist and a misogynist and becoming an old man. His father had died a pauper and now he was about to die one too. Except for Social Security, a government program he would have ended if he could have. He had given at least one of his millions of dollars to the right wing of the Republican party. Now he was being taken care of by Social Security and Medicare. He saw the irony. What he could not see was how the weak destroy the strong within a family as well as in larger worlds. This happens in every family. It is as inevitable as the sun and rain. All the daughter wanted to know was how to keep it from happening to her.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_prologue.vue?152e601e